var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CONFIG } from "@/config";
import { DEFAULT_LOCALE, localeToLang } from "../locales";
var requireSfx = CONFIG.sfx.folder;
var SFX_MAPPING = requireSfx.keys().map(function (key) {
    var conf = CONFIG.sfx.namePattern(key);
    return __assign({ key: key }, conf);
});
console.log(SFX_MAPPING);
export function getAudioForPages(leftPage, locale) {
    var sfx = SFX_MAPPING.find(function (e) {
        return e.pages.includes(leftPage) &&
            (e.locale === localeToLang(locale) || e.locale == null);
    });
    if (sfx != null) {
        return requireSfx(sfx.key);
    }
    var defaultSfx = SFX_MAPPING.find(function (e) {
        return e.pages.includes(leftPage) &&
            (e.locale === localeToLang(DEFAULT_LOCALE) || e.locale == null);
    });
    if (defaultSfx != null) {
        return requireSfx(defaultSfx.key);
    }
    return null;
}
